import React, { Suspense } from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import "./i18next";
import {Spin} from 'antd'

ReactDOM.render(
  <React.StrictMode>
    <Suspense fallback={<div style={{minHeight:'100vh' , display:'flex' , justifyContent:'center' , alignItems:'center'}}><Spin size='large' spinning={true}/></div>}>
      <App />
    </Suspense>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
